<div class="vendor-profile-component-main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorDashboard()">Vendor Management</span>
    <span>  / </span>
  <span class="breadcrumb-text" (click)="navigateBack()">{{ vendorList.vendorList }}</span>
    <span>  / </span>
  <span class="breadcrumb-text">{{ vendorList.vendorProfile }}</span>
  </div>
  <div class="vendor-profile-container">
    <h1 class="title">{{ vendorName }}</h1>
    <div class="top-section">
      <app-contractor-vendor-head-count [selectedVendor]="vendorName" [vendorId]="vendorId"></app-contractor-vendor-head-count>
      <app-interviews-status [vendorId]="vendorId"></app-interviews-status>
    </div>
    <!-- Quarterly Feedback Section -->
    <div class="quarterly-feedback-section">
      <h2 class="section-heading">Quarterly Feedback</h2>
      <app-quarterly-feedback [vendorId]="vendorId"></app-quarterly-feedback>
    </div>
    <div class="vendor-info-section">
      <h2 class="section-heading">Vendor Information</h2>
      <app-vendor-info [vendorId]="vendorId"></app-vendor-info>
    </div>
  </div>
</div>
